import { ReviewOptionsField } from '../reviewOptionsField/reviewOptionsField';
import type { ReviewOptionsFieldProps } from '../reviewOptionsField/reviewOptionsField';

export type ActivitiesFieldProps = Pick<
  ReviewOptionsFieldProps,
  'onChange' | 'options' | 'selectedIds'
>;

/** "What is this product good for?" section. Options are the `activity` tags. */
export function ActivitiesField(props: ActivitiesFieldProps) {
  return (
    <ReviewOptionsField
      {...props}
      isOptional
      legend="What is this product good for?"
      testId="activities-field"
    />
  );
}
